module.exports = __webpack_public_path__ + "static/img/3.cd330c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/3.jpg
// module id = 18fF
// module chunks = 2